<template>
    <div>
        <BTable striped :items="tender.invitations" :fields="fields" caption-top responsive="sm">
            <template #table-caption>
                <BButton variant="success" @click="addRow">Додати</BButton>
            
            </template>
         
            <template v-slot:cell(contact)="{ value, item, field: { key }}">
                <BFormInput v-model="item[key]" type="text" placeholder="Петро петрович" :state="value.length > 3 ? true : false"/>
            </template>
         
            <template v-slot:cell(email)="{ value, item, field: { key }}">
                <BFormInput
                    v-model="item[key]"
                    type="email"
                    placeholder="contact@example.com"
                    :state="isValidEmail(value)"/>
            </template>
            
            <template  v-slot:cell(dell_row)="row">
                <div class='icon-stack cursor-pointer fs-xxl'  v-on:click="dellRow(row)">
                    <i class="base base-1 icon-stack-3x opacity-100 color-danger-600"></i>
                    <i class="far fa-trash-alt icon-stack-1x opacity-100 color-white"></i>
                </div>
            </template>
        
        </BTable>
    </div>
</template>

<script>

import {
    BTable,
    BButton,
    BFormInput,
    
    
} from 'bootstrap-vue-next';

export default {
    name: "tender_invitations",
    emits : ['changeAtr'],
    
    components : {
        BTable,
        BButton,
        BFormInput
    },
    
    props : {
        tender : {
            type : Object
        }
    },
    
    data() {
        return {
            fields: [
                {
                    key: 'contact',
                    label: "ПІБ",
                    sortable: true
                },
                {
                    key: 'email',
                    sortable: true
                },
                {
                    key: 'dell_row',
                    label: "Видалити",
                }],
        }
    },
    
    methods:{
        addRow(){
            this.tender.invitations.push({contact:'',email:''})
        },
        
        dellRow(row){
            this.tender.invitations.splice(row.index,1);
            
        },
        
        isValidEmail(email)
        {
            let re = /\S+@\S+\.\S+/;
            return (re.test(email));
        }
        
    }
    
}
</script>



<style scoped>

</style>